import { Controller } from "@hotwired/stimulus"
import Pagy from "../vendor/pagy.mjs"
import { onMorph } from "../lib/reactor"

export default class extends Controller {
  connect() {
    onMorph(this)
    this.install()
  }

  morph() {
    this.install()
  }

  install() {
    // Init must stay sync. Awaiting cookieStore leaves bare ?page=N links.
    this.ensureCookie()
    Pagy.init(this.element)
    this.promoteCookie()
    requestAnimationFrame(() => this.promoteCookie())
  }

  ensureCookie() {
    const value = this.cookieValue() || Math.floor(Math.random() * 36 ** 3).toString(36)
    this.writeCookie(value)
  }

  // Pagy writes `pagy=` with no Path after ResizeObserver. Keep one Path=/ cookie.
  promoteCookie() {
    const value = this.cookieValue()
    if (value) this.writeCookie(value)
  }

  cookieValue() {
    return document.cookie.split(/;\s+/).find((row) => row.startsWith("pagy="))?.split("=")[1]
  }

  writeCookie(value) {
    document.cookie = `pagy=${value}; Path=/; SameSite=Lax`
    this.scrubStaleCookies(value)
  }

  async scrubStaleCookies(value) {
    if (!globalThis.cookieStore) return

    const stale = await cookieStore.getAll("pagy")
    for (const cookie of stale) {
      const path = cookie.path || "/"
      if (path === "/" && cookie.value === value) continue
      await cookieStore.delete({name: "pagy", path})
    }

    document.cookie = `pagy=${value}; Path=/; SameSite=Lax`
  }
}
